import { Injectable } from '@angular/core';
import { StorageUtil, ExpiredUnit, isBrowser } from './util';

export class StorageService {
  constructor(private storage: Storage) {}

  get(key: string) {
    return StorageUtil.get(this.storage, key);
  }

  set(
    key: string,
    value: any,
    expiredAt: number = 0,
    expiredUnit: ExpiredUnit = 'd',
  ) {
    return StorageUtil.set(this.storage, key, value, expiredAt, expiredUnit);
  }

  /**
   * å é¤æå®keyï¼å¦ï¼
   * - `remove('key')` å é¤ `key` é®
   * - `remove(/BMap_\w+/)` æ¹éå é¤ææ BMap_ å¼å¤´çé®
   * @param key é®åææ­£åè¡¨è¾¾å¼
   */
  remove(key: string | RegExp) {
    if (typeof key === 'string') {
      StorageUtil.remove(this.storage, key);
      return;
    }
    let index = 0;
    let next = StorageUtil.key(this.storage, index);
    const ls: string[] = [];
    while (next) {
      if (key.test(next)) ls.push(next);
      next = StorageUtil.key(this.storage, ++index);
    }
    ls.forEach(v => StorageUtil.remove(this.storage, v));
  }

  clear() {
    this.storage.clear();
  }
}

@Injectable({ providedIn: 'root' })
export class LocalStorageService extends StorageService {
  constructor() {
    super(isBrowser ? localStorage : null);
  }
}

@Injectable({ providedIn: 'root' })
export class SessionStorageService extends StorageService {
  constructor() {
    super(isBrowser ? sessionStorage : null);
  }
}
